import {
  GET_STARTED_ROUTE,
  DIRECT_MAILER_ROUTE,
  DEBT_RELIEF_APPLY_ROUTE,
  ADVERTORIAL_ROUTE,
  LANDER_ROUTE,
  LANDING_PAGE_ROUTE,
  WALL_OF_FAME_ROUTE,
  MOBILE_APP_DOWNLOAD_FDR_ROUTE,
  CONSULTATION_BILLS,
  ACHIEVE_GOOD_APP_URL,
  ACHIEVE_GET_STARTED_URL,
  FDR_GET_STARTED_ROUTE,
  GET_STARTED_PATH,
} from 'constants/navigation'

const isGetStartedRoute = (href, mode = 'startsWith') => {
  if (mode === 'includes') {
    return href !== undefined && href?.trim()?.includes(GET_STARTED_PATH)
  }
  return (
    href !== undefined &&
    href?.trim()?.replace('/', '').startsWith(GET_STARTED_ROUTE.split('?')[0].replace('/', ''))
  )
}

const isFdrGetStartedRoute = (href) => {
  return href !== undefined && href?.trim()?.includes(FDR_GET_STARTED_ROUTE)
}

const isConsultationBillsRoute = (href) => {
  return href !== undefined && href?.trim()?.includes(CONSULTATION_BILLS)
}

const isAchieveGoodAppRoute = (href) => {
  return href !== undefined && href?.trim()?.includes(ACHIEVE_GOOD_APP_URL)
}

const isAchieveGetStartedRoute = (href) => {
  return href !== undefined && href?.trim()?.includes(ACHIEVE_GET_STARTED_URL)
}

const isResolveApplyRoute = (href) => {
  return href !== undefined && href?.startsWith(DEBT_RELIEF_APPLY_ROUTE)
}

const isDirectMailerRoute = (href) => {
  return (
    href !== undefined &&
    href?.trim()?.replace('/', '').startsWith(DIRECT_MAILER_ROUTE.split('?')[0].replace('/', ''))
  )
}

const isStandaloneRoute = (route) => {
  if (!route) return false
  return (
    route.includes(ADVERTORIAL_ROUTE) ||
    route.includes(LANDER_ROUTE) ||
    route.includes(LANDING_PAGE_ROUTE) ||
    route.includes(WALL_OF_FAME_ROUTE) ||
    route.includes(MOBILE_APP_DOWNLOAD_FDR_ROUTE)
  )
}

export {
  isResolveApplyRoute,
  isGetStartedRoute,
  isDirectMailerRoute,
  isStandaloneRoute,
  isConsultationBillsRoute,
  isAchieveGoodAppRoute,
  isAchieveGetStartedRoute,
  isFdrGetStartedRoute,
}
